import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { MENU_CALENDAR_ITEM } from '../../../constants/menu'
import { usePageBrowserTabTitle } from '../../../hooks'
import { Page, PageActions } from '../../Page'
import { PageHeader } from '../../PageHeader'
import { CalendarHeaderActionsContainerContext } from '../Calendar.contexts'
import { CalendarSection } from '../CalendarSection'

import { QA_NAME_CALENDAR_PAGE } from './CalendarPage.constants'

function CalendarPage() {
  const { t } = useTranslation()

  const [headerActionsContainer, setHeaderActionsContainer] = useState(null)

  usePageBrowserTabTitle({ pageTitle: t('BrowserTab.CalendarPageTitleKey') })

  return (
    <Page qaName={QA_NAME_CALENDAR_PAGE}>
      <PageHeader title={t(MENU_CALENDAR_ITEM.title)}>
        <PageActions ref={setHeaderActionsContainer} />
      </PageHeader>
      <CalendarHeaderActionsContainerContext value={headerActionsContainer}>
        <CalendarSection />
      </CalendarHeaderActionsContainerContext>
    </Page>
  )
}

export default CalendarPage
